export default "__VITE_PUBLIC_ASSET__6b595861__"